module.exports = __webpack_public_path__ + "img/imgs1.4c22f970.png";